import { render } from "./DropdownButton.vue?vue&type=template&id=ccdf25f4&scoped=true"
const script = {}

import "./DropdownButton.vue?vue&type=style&index=0&id=ccdf25f4&scoped=true&lang=css"

import exportComponent from "/home/nils/assessment_tool/code/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccdf25f4"]])

export default __exports__